export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-ef03ae8c29ea21c430af69ff5055c5de.svg";